// Updates a tax's tax_organizer_sent in the tax table and offcanvas view.
// Updates a tax's preparer in the tax table and offcanvas view.
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)

    // Add global keydown listener when dropdown opens
    this.element.addEventListener('shown.bs.dropdown', () => {
      document.addEventListener('keydown', this.handleKeydown)
    })

    // Remove global keydown listener when dropdown closes
    this.element.addEventListener('hidden.bs.dropdown', () => {
      document.removeEventListener('keydown', this.handleKeydown)
    })
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown)
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      // Find the dropdown toggle and close it
      const dropdownToggle = this.element.querySelector('[data-bs-toggle="dropdown"]')
      if (dropdownToggle) {
        const dropdown = bootstrap.Dropdown.getInstance(dropdownToggle)
        if (dropdown) {
          // Stop propagation to prevent closing parent offcanvas/modal
          event.stopPropagation()
          event.preventDefault()
          dropdown.hide()
        }
      }
    }
  }

  handleUpdate(event) {
    event.preventDefault()
    const url = event.target.dataset.url
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    if (event.target.dataset.confirmation && !confirm(event.target.dataset.confirmation)) { return; }
    else {
      fetch(url, {
        method: event.target.dataset.method || 'PUT',
        headers: {
          'X-CSRF-Token': csrfToken,
          "Content-Type": 'text/vnd.turbo-stream.html',
          'Accept': "text/vnd.turbo-stream.html"
        }})
        .then(response => response.text())
        .then(html => Turbo.renderStreamMessage(html))
    }
  }
}

